<template>
  <div id="product-tabs" class="product-info">
    <ui-tabs
      v-model="tab"
      :items="tabs"
      @click-tab="onClickTab"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  DELIVERY_INFO_DATA,
  DESCRIPTION_INFO_DATA,
  REVIEW_INFO_DATA,
} from '@/components/product/info-blocks/info-blocks-config';
import productInfoBlocksMixin from '@/mixins/product-info-blocks';
import { productGtmEvents } from '@/gtm/product';

export default {
  name: 'product-info',

  mixins: [productInfoBlocksMixin],

  props: {
    productCode: {
      type: String,
      default: '',
    },
    cityName: {
      type: String,
      default: '',
    },
    activeSku: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      tab: 'description'
    }
  },

  computed: {
    ...mapGetters({
      REVIEWS_COUNT: 'product/reviewsСount',
    }),

    tabs() {
      return this.availableItems.map(({
        key,
        name,
        counterGetter,
      }) => ({
        key,
        name,
        component: this.getComponent(key),
        badge: this.$store.getters[counterGetter],
      }))
    }
  },

  methods: {
    onClickTab(key) {
      if (key === DESCRIPTION_INFO_DATA.key && this.productCode) {
        productGtmEvents.card.clickDescriptionTab({ productCode: this.productCode });
      }

      if (key === REVIEW_INFO_DATA.key && this.productCode) {
        productGtmEvents.reviews.clickTab({
          productCode: this.productCode,
          reviewsCount: this.REVIEWS_COUNT,
        });
      }

      if (key === DELIVERY_INFO_DATA.key && this.productCode) {
        productGtmEvents.card.clickDeliveryTab({
          productCode: this.productCode,
          cityName: this.cityName,
          activeSku: this.activeSku,
        });
      }
    },
  }
}
</script>

<style lang="scss">
.product-info {
  margin-top: 24px;

  &-description {
    margin: 24px 0;
  }
}

@include breakpoint("tablet") {
  .product-info {
    margin-top: 32px;
  }
}
</style>
